/** The portal builder stores manual-label instructions one per line. */
export function manualLabelInstructionLines(
  text: string | null | undefined,
): string[] {
  return (text ?? "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
}

/** The portal confirmation page's instructions, else `defaults`. */
export function resolveManualLabelInstructions({
  portalText,
  defaults,
}: {
  portalText: string | null | undefined;
  defaults: readonly string[];
}): string[] {
  const portal = manualLabelInstructionLines(portalText);
  return portal.length ? portal : [...defaults];
}
